import { createStore, applyMiddleware } from 'redux';
import rootReducer from './reducers';

import { composeWithDevTools } from 'redux-devtools-extension';
import reduxThunk from 'redux-thunk';

const initialSate = {};
const middleWare = [reduxThunk];

const store = createStore(rootReducer, initialSate, composeWithDevTools(applyMiddleware(...middleWare)));


export default store;